export enum AdminApiEnumConfigurations {
  SystemType = "SystemType",
  SystemProvider = "SystemProvider",
  SystemImplementationType = "SystemImplementationType",
  ServiceType = "ServiceType",
  SupportedLanguage = "SupportedLanguage",
  TimeZone = "TimeZone",
  HideableMemberField = "HideableMemberField",
  LicencedCherryHubProduct = "LicencedCherryHubProduct",
  CalendarMonths = "CalendarMonths",
  MemberKeyField = "MemberKeyField",
  SupportedCustomClaim = "SupportedCustomClaim",
  Country = "Country",
  AllowableInputStringCharacters = "AllowableInputStringCharacters",
  DeliveryType = "DeliveryType",
  ProgramType = "ProgramType",
  MemberLookupMethod = "MemberLookupMethod",
  Party = "Party",
  ServiceName = "ServiceName",
  MatchableMemberField = "MatchableMemberField",
  FieldValidationRegexType = "FieldValidationRegexType",
  CloudServiceManagementRole = "CloudServiceManagementRole",
}
